import { render, staticRenderFns } from "./questionResult.vue?vue&type=template&id=ef1ab6ea&scoped=true&"
import script from "./questionResult.vue?vue&type=script&lang=js&"
export * from "./questionResult.vue?vue&type=script&lang=js&"
import style0 from "./questionResult.vue?vue&type=style&index=0&id=ef1ab6ea&prod&lang=scss&"
import style1 from "./questionResult.vue?vue&type=style&index=1&id=ef1ab6ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1ab6ea",
  null
  
)

export default component.exports